module.exports = __webpack_public_path__ + "fonts/agencyfb.596e78c7.ttf";